import styled from 'styled-components';

export const HeroSection = styled.section`
	text-align: center;
	padding: 60px 20px 40px;
	background:
		linear-gradient(180deg, rgba(24, 119, 242, 0.08) 0%, rgba(255, 255, 255, 0) 100%),
		linear-gradient(135deg, #eef2ff 0%, #fdf2f8 100%);
	margin-bottom: 30px;
	width: 100vw;
	margin-left: calc(-50vw + 50%);
`;

export const HeroTitle = styled.h1`
	font-size: 2.5rem;
	font-weight: 700;
	margin-bottom: 20px;
	background: linear-gradient(135deg, #1877f2 0%, #8b5cf6 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;

	@media (max-width: 768px) {
		font-size: 2rem;
	}
`;

export const HeroDescription = styled.p`
	font-size: 1.125rem;
	color: #6b7280;
	max-width: 620px;
	margin: 0 auto;
	line-height: 1.6;

	@media (max-width: 768px) {
		font-size: 1rem;
	}
`;
